'use strict';

import header from '../components/header';
import footerTray from '../components/footer-tray';
import headerNavigation from '../components/header-navigation';
import headerSearch from '../components/header-search';
import carousel from '../components/carousel';
import productTiles from '../components/product-tile';

import backdropHelper from '../helpers/backdrop';
import imagesHelper from '../helpers/images';
import viewportHelper from '../helpers/viewport';

import simpleToggle from '../behaviors/simple-toggle';
import focusable from '../behaviors/focusable';

import pageSearch from '../pages/search';
import pageError from '../pages/error';

import analytics from '../analytics';
import countries from '../countries';
import dialog from '../dialog';
import quickview from '../quickview';
import page from '../page';
import rating from '../rating';
import tooltip from '../tooltip';
import util from '../util';
import foundation from '../foundation';
import filtershades from '../filtershades';
import validator from '../validator';
import tls from '../tls';
import video from '../video';
import footerSelector from '../footer-selector';
import newsletter from '../newsletter';
import inputEntry from '../input-entry';
import main from '../main';
import contactus from '../pages/contactus';
import '../jquery-ext';
import '../cookieprivacy';

import product from '../pages/product';
import tutorial from '../pages/tutorial';

import storelocator from '../pages/storelocator';
import content from '../pages/content';
import promotionlanding from '../pages/promotionlanding';
import regimenselector from '../pages/regimenselector';
import customerservice from '../pages/customerservice';
import marketsampling from '../marketsampling';
var pages = {
    product,
    tutorial,
    storelocator,
    content,
    promotionlanding,
    regimenselector
};



pages.search = pageSearch;
pages.error = pageError;

window.app = {
    init: () => {
    	window.sgDialog = dialog;
    	window.sgUtil = util;
        const $ = window.jQuery;
        $(document).foundation();
        main.init();

        // Initialize ES6 Modules
        footerTray.init($);
        header.init($);
        headerNavigation.init($);
        headerSearch.init($, Resources.SIMPLE_SEARCH);
        carousel.init($);
        backdropHelper.init($);
        productTiles.init($);
        imagesHelper.initLazyLoaded($);
        imagesHelper.loadProductImages($);
        viewportHelper.listenForPageEvents($);
        newsletter.init();
        simpleToggle.init($);
        focusable.init($);
        contactus.initContactUs();
        customerservice.initFAQ();
        
        if (document.cookie.length === 0) {
            $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
        }


        /*backToTopHandler();
        Removing back-to-top as per LUB2-993 - Not in design
        */

        // init specific global components
        analytics.init();
        countries.init();
        tooltip.init();

        foundation.init();

        validator.init();
        rating.init();
        video.init();
        footerSelector.countrySelector();
        marketsampling.init();
        newsletter.newsletterHeader();
        newsletter.isNewsletterEnabled();
        newsletter.newsletterPersistentFooter();
        newsletter.newsletterMobile();
        newsletter.signUpEventListener();
        newsletter.signUpFooter();
        newsletter.footerNewsletter();
        newsletter.newsletterPersistentFooterMobile();
        inputEntry.entry();
        util.updateWithCsrfInputAjax();//add csrf for post ajax call

        // execute page specific initializations
        $.extend(page, window.pageContext);

        var ns = page.ns;

        if (ns && pages[ns] && pages[ns].init) {
            pages[ns].init($);
        }

        // Check TLS status if indicated by site preference
        if (SitePreferences.CHECK_TLS === true) {
            tls.getUserAgent();
        }

    }
};


// expose global app obj for 3rd party integrations
window.app.quickView = quickview;
window.app.user = window.User;
window.app.SCemailUrl = window.Urls.SCemailUrl;
window.app.Product = {};
window.app.tagmanager = analytics.tagmanager;
window.app.gtmInternalPromotion = analytics.gtmInternalPromotion;

// expose global saveURL to support legacy Composed integration
window.saveURL = window.Urls.saveConsultationURL;
// summary scroll bar global scope
window.addSummaryScrollbar = main.addSummaryScrollbar;


// Initialize Application
$(() => { window.app.init(); });


